export default __webpack_public_path__ + "static/media/Message-v2.1762a906.svg";